module.exports = __webpack_public_path__ + "static/media/unicorn.2b402bf4.png";